/**
 * Created by Jerker Nord on 2024-02-15.
 */

import {gsap} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class TimelineAnimatedSprite extends PIXI.AnimatedSprite {

    private static DEFAULT_FPS:number = 60;

    private _repeats:number;
    private _mainTL:gsap.core.Timeline;
    private _delayTL:gsap.core.Timeline;
    private _delay:number;
    private _fps:number;

    constructor(textures:PIXI.Texture[], repeats:number, fps:number = 30) {
        super(textures);
        this._repeats = repeats;
        this._fps = fps;
        this.init();
    }

    private init():void {
        this.animationSpeed = MathHelper.floorToDecimals((this._fps / TimelineAnimatedSprite.DEFAULT_FPS), 4);
        this._delay = 0.001;
        if(this._repeats > 0) {
            this.loop = false;
            this._delay = (this.textures.length / this._fps) * this._repeats;
        }
        this.onComplete = () => this.onAnimationEnd();
    }

    //Do not use if looping
    public getPlayTL():gsap.core.Timeline {
        this._mainTL = gsap.timeline({onComplete : () => this.onTLComplete()});
        this._delayTL = gsap.timeline({delay : this._delay});

        this._mainTL.add([
            () => {this.play()},
            this._delayTL
        ]);

        return this._mainTL;
    }

    public onAnimationEnd():void {
        this._repeats--;
        if(this._repeats > 0) {
            this.gotoAndPlay(0);
        }
    }

    public onTLComplete():void {
    }

}